import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { PremiumDiscountResponse } from 'src/app/models/premium-discount-response.model'

@Injectable({
  providedIn: 'root',
})
export class PremiumDiscountService {
  public static readonly premiumDiscountEndpoint = '/premium-discount'

  constructor(private readonly http: HttpClient) {}

  getPremiumDiscount(
    fundId: string,
    type: string,
  ): Observable<PremiumDiscountResponse> {
    const premiumDiscountEndpoint =
      PremiumDiscountService.premiumDiscountEndpoint.concat(`/${type}`)
    return this.http.get<PremiumDiscountResponse>(
      `vmf/api/${fundId}`.concat(premiumDiscountEndpoint),
    )
  }
}
